// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

h1.ce-header {
	font-size: 34pt;
}

h2.ce-header {
	font-size: 30pt;
}

h3.ce-header {
	font-size: 26pt;
}

h4.ce-header {
	font-size: 22pt;
}

h5.ce-header {
	font-size: 18pt;
}

h6.ce-header {
	font-size: 14pt;
}
*/`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/block-header/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;CAAA","sourcesContent":["/*\r\n\r\nh1.ce-header {\r\n\tfont-size: 34pt;\r\n}\r\n\r\nh2.ce-header {\r\n\tfont-size: 30pt;\r\n}\r\n\r\nh3.ce-header {\r\n\tfont-size: 26pt;\r\n}\r\n\r\nh4.ce-header {\r\n\tfont-size: 22pt;\r\n}\r\n\r\nh5.ce-header {\r\n\tfont-size: 18pt;\r\n}\r\n\r\nh6.ce-header {\r\n\tfont-size: 14pt;\r\n}\r\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
